type BadgeProps = {
  label: 'Community';
};

export function Badge({ label }: BadgeProps) {
  return (
    <div className="relative flex h-[18px] items-center justify-center rounded-full bg-[#F5F5F5] px-1.5 dark:bg-[#262626]">
      <span className="text-[8px]/4 font-semibold text-[#737373] drop-shadow-sm dark:text-[#A3A3A3]">
        {label}
      </span>
    </div>
  );
}
